import React, { useState } from "react";
import { Box, Typography } from "@material-ui/core";
import {
  CustomAsyncAutocomplete,
  CustomButton,
  CustomDialog,
} from "../../../../../Components";

import {
  BulkAssignAfterSales,
  GetAfterSalesAgents,
} from "../../../../../Services";
import { useSelectedTheme, useTranslate } from "../../../../../Hooks";

import useStyles from "./styles";

import { Globe01Icon } from "../../../../../assets/icons";
import { useVerticalNav } from "../../../../../Contexts/VerticalNavContext";

function AssignOwnerDialog({ contactIds, onClose = () => {}, refetch, open }) {
  const styles = useStyles();

  const { translate } = useTranslate("AfterSalesView");

  const {
    theme: { palette },
  } = useSelectedTheme();

  const [salesAgents, setSalesAgents] = useState([]);
  const { setAlertBoxContent } = useVerticalNav();

  const handleBulkAssign = async (params, isClear = false) => {
    try {
      const res = await BulkAssignAfterSales(params);
      if (!(res && res.status && res.status !== 200)) {
        if (!isClear) {
          setAlertBoxContent({
            display: true,
            variant: "success",
            title: translate("Owner Assigned Successfully"),
            onClose: () => {
              setAlertBoxContent(null);
            },
          });
        }
        if (refetch) refetch();
      }
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("Error Assigning Owner"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
    onClose();
  };

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title={"Assign after sale owner "}
      subtitle={"Select an after sale owner to assign to selected clients "}
      paperClassName={styles.dialogWrapper}
      content={
        <Box className={styles.fieldsSection}>
          <CustomAsyncAutocomplete
            rootCustomClasses={styles.inputwrapper}
            popoverClasses={styles.popoverClasses}
            className={styles.customAutocomplete}
            placeholder={"Agent Name"}
            labelValue={"After sale owner"}
            onFetchData={GetAfterSalesAgents}
            filter={{ pageIndex: 0, pageSize: 1000 }}
            displayLabel={(option) => option?.fullName ?? ""}
            renderOption={(option) => (
              <Box className={styles.optionWrapper}>
                <span className={styles.name}>{option?.fullName}</span>{" "}
                <span>Clients: {option?.assignedCount}</span>{" "}
                {option.languages.length > 0 && (
                  <span className={styles.languages}>
                    <Globe01Icon fill={palette.utility.utility_gray_500} />{" "}
                    {option.languages
                      .map((lan) => lan.lookupItemName)
                      .join(", ")}
                  </span>
                )}
              </Box>
            )}
            chipsLabel={(option) => {
              return option?.fullName;
            }}
            onChange={(_e, value) => {
              setSalesAgents(value);
            }}
            getOptionSelected={(option, value) =>
              option?.userId === value?.userId
            }
            mapper={(data) => data}
            filterOptions={(options, state) =>
              options.filter(
                (option) =>
                  option.email
                    .toLowerCase()
                    .includes(state.inputValue.toLowerCase()) ||
                  option.fullName
                    .toLowerCase()
                    .includes(state.inputValue.toLowerCase())
              )
            }
          />
          <Box className={styles.selectedAgentsSection}>
            <Typography className={styles.selectedAgentsTitle}>
              Selected Clients: {contactIds.length}
            </Typography>
            <CustomButton
              variant="outlined"
              color="secondary"
              onClick={() =>
                handleBulkAssign({ contactIds, newUserId: null }, true)
              }
            >
              {translate("clear-assigned-agent")}
            </CustomButton>
          </Box>
        </Box>
      }
      confirmText={"Save"}
      onConfirm={() => {
        handleBulkAssign({ contactIds, newUserId: salesAgents.userId }, false);
      }}
    />
  );
}

export default AssignOwnerDialog;
